import styled from 'styled-components';

import {
  Button as ButtonLayoutComponent, CenteredLoader, Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    width: 650px;
    margin-top: 100px;
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    min-height: 200px;
  }
`;

const Text = styled(TextLayoutComponent)``;

const Title = styled(TextLayoutComponent.Bold)`
  margin-bottom: 10px;
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin: 25px auto 0;
    display: block;
    min-width: 130px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 25px 40px 40px 40px;
`;

const Loader = styled(CenteredLoader)``;

const BlueStrip = styled.div`
  background-color: ${(props) => props.theme.color.primary};
  height: 12px;
`;

const Content = styled.div`
  padding: 30px 70px;
`;

export {
  Segment,
  Text,
  Title,
  Button,
  Container,
  Loader,
  BlueStrip,
  Content,
};
